import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';
import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { ICoordinates } from '../../../types/geo';
import { MapPin } from '../../../components/MapPin';

export interface IGetGeoObjectOptions {
  name: string;
  coordinates?: ICoordinates | null;
  id?: string | null;
  pinImage: string | null;
}

export const getGeoObject = ({ name, coordinates, id, pinImage }: IGetGeoObjectOptions): IMapGeoObject | null => {
  const lat = coordinates?.lat;
  const lng = coordinates?.lng;

  if (!lat || !lng || !id) {
    return null;
  }

  return {
    type: 'Point',
    name,
    options: {
      coordinates: { lat, lng },
      html: ReactDOMServer.renderToStaticMarkup(<MapPin image={pinImage} />),
      id,
      width: 32,
      height: 32,
    },
  };
};
